import { useState } from 'react'

import useRedux from '../../../hooks/useRedux'
import useTranslations from '../../../hooks/useTranslations'
import { setPopupMessageModel } from '../../../redux/app/reducer'
import { dayJs, SAVE_FORMAT } from '../../../utils/dayjs'
import { exportToExcelApi } from '../report.api'

const BANK_PAYMENT_SHEET = 'BANK_PAYMENT_SHEET'

const bankPaymentReport = () => {
  const { t } = useTranslations()
  const { dispatch } = useRedux()
  const [selectedDate, setSelectedDate] = useState(dayJs())
  const [loading, setLoading] = useState(false)
  const [viewPreviousHistory, setViewPreviousHistory] = useState({
    open: false,
    sheetType: BANK_PAYMENT_SHEET,
  })

  const onDateChange = date => {
    setSelectedDate(date)
  }

  const generateReport = async ({ sheetType }) => {
    if (!selectedDate) {
      dispatch(
        setPopupMessageModel({
          open: true,
          message: t('msg_PleaseSelectDate'),
          success: false,
        }),
      )
      return
    }

    setLoading(true)
    try {
      const response = await exportToExcelApi({
        payload: {
          type: sheetType,
          processedForPaymentDate: selectedDate?.format(SAVE_FORMAT),
        },
      })

      if (response?.data?.success) {
        dispatch(
          setPopupMessageModel({
            open: true,
            message: t('msg_ReportGenerated'),
            success: true,
          }),
        )
      }
    } finally {
      setLoading(false)
    }
  }

  const onGenerateBankPaymentReport = () =>
    generateReport({ sheetType: BANK_PAYMENT_SHEET })

  const onViewPreviousHistory = () => {
    setViewPreviousHistory(prev => ({
      ...prev,
      open: true,
      sheetType: BANK_PAYMENT_SHEET,
    }))
  }

  const onViewHistoryModelClose = () => {
    setViewPreviousHistory(prev => ({ ...prev, open: false }))
  }

  return {
    t,
    loading,
    selectedDate,
    viewPreviousHistory,
    onDateChange,
    onGenerateBankPaymentReport,
    onViewPreviousHistory,
    onViewHistoryModelClose,
  }
}

export { BANK_PAYMENT_SHEET }
export default bankPaymentReport
